import React from 'react';

const FOOTER_HEIGHT = 96;

function Footer() {
  const version = process.env.REACT_APP_VERSION || 'UNKNOWN';
  const items = [
    { name: 'Feedback', link: 'https://www.bartshealth.nhs.uk/feedback' },
    { name: 'Get in touch', link: 'https://www.bartshealth.nhs.uk/pals' },
    { name: 'Terms and conditions', link: 'https://www.bartshealth.nhs.uk/privacy' },
    { name: 'Your privacy', link: 'https://www.bartshealth.nhs.uk/privacy' },
  ];

  return (
    <footer
      role="contentinfo"
      style={{
        flexShrink: 0,
        height: FOOTER_HEIGHT,
        boxSizing: 'border-box',
        marginTop: 'auto',
        overflow: 'hidden',
      }}
    >
      <div
        className="nhsuk-footer-container"
        style={{
          height: '100%',
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div className="nhsuk-width-container" style={{ width: '100%' }}>
          <h2 className="nhsuk-u-visually-hidden">Support links</h2>
          <ul className="nhsuk-footer__list" style={{ marginBottom: 4 }}>
            {items.map((item, index) => (
              <li key={index} className="nhsuk-footer__list-item nhsuk-footer-default__list-item">
                <a className="nhsuk-footer__list-item-link" href={item.link}>
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
          <p className="nhsuk-footer__copyright" style={{ marginBottom: 0 }}>
            © Crown copyright - Build {version}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
